/* Tira o zoom automatico do iOS nos campos do popup do Shopify Forms (Match Day).
 *
 * O Safari do iPhone da zoom em qualquer campo com font-size abaixo de 16px, e os
 * campos do app vem com 14px. O app renderiza dentro de um shadow DOM, entao o CSS do
 * tema nao alcanca: a unica forma de estilizar por fora e injetar um <style> dentro do
 * proprio shadow root, que e o que este script faz.
 *
 * A regra vale so em tela de toque (pointer: coarse). No desktop o formulario continua
 * exatamente como estava.
 *
 * Se o app mudar de nome de elemento ou fechar o shadow root, o script simplesmente nao
 * acha nada e sai quieto - a loja segue normal, so volta o zoom.
 */
(function () {
  "use strict";

  var MARCA = "data-md-nozoom";
  var CSS =
    "@media (pointer: coarse){" +
    "input:not([type=checkbox]):not([type=radio]):not([type=range])," +
    "textarea,select{font-size:16px !important}}";

  function injetar(raiz) {
    if (!raiz || raiz.querySelector("style[" + MARCA + "]")) return false;
    var s = document.createElement("style");
    s.setAttribute(MARCA, "1");
    s.textContent = CSS;
    raiz.appendChild(s);
    return true;
  }

  /* O elemento do app entra na pagina antes do shadow root existir, e o shadow root
     antes dos campos. Injetar cedo cobre tudo: o <style> vale pro que vier depois. */
  function varrer() {
    var achou = false;
    var todos = document.querySelectorAll("*");
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      if (el.tagName.indexOf("SHOPIFY-FORMS") !== 0 || !el.shadowRoot) continue;
      if (injetar(el.shadowRoot)) achou = true;
    }
    return achou;
  }

  varrer();

  /* O app carrega em algum momento depois do HTML. Observo as insercoes e, quando o
     elemento aparece, tento por alguns segundos ate o shadow root existir. */
  if (window.MutationObserver) {
    var tentativas = 0;
    var timer = null;

    function insistir() {
      if (timer) return;
      timer = setInterval(function () {
        tentativas++;
        if (varrer() || tentativas > 100) {
          clearInterval(timer);
          timer = null;
        }
      }, 150);
    }

    var obs = new MutationObserver(function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var novos = mutacoes[i].addedNodes;
        for (var j = 0; j < novos.length; j++) {
          var n = novos[j];
          if (n.nodeType === 1 && n.tagName.indexOf("SHOPIFY-FORMS") === 0) {
            insistir();
            return;
          }
        }
      }
    });
    obs.observe(document.documentElement || document, { childList: true, subtree: true });

    /* Rede de seguranca: se o elemento ja estava na pagina antes do observer, ou se o
       app o insere por um caminho que o observer nao pega, uma janela curta resolve. */
    if (document.querySelector("shopify-forms-embed")) insistir();
    window.addEventListener("load", insistir);
  }
})();
